module.exports = __webpack_public_path__ + "static/media/empty-state-airport.92dc96d3.svg";